<template>
  <div class="kChartDetail">
    <div class="kChart">
      <div v-if="listK.length" class="chart">
        <slot name="rightTool" />
        <ChartK :security-type="securityType" :data-list="listK" :digit="2" :xaxis="xaxis" :curline="curline"
          :range="range" :isfresh="isfresh" :current-index="currentIndex" :isCard="isCard" :type="type" @getma="getma"
          @getHoverData="getHoverData" :mark-data="sallOutMark" class="chartMin" />
      </div>

      <div v-if="!listK.length" class="nodata">
        <div class="nodImg" />
        <div class="nodtx">{{ "暂无图表数据" }}</div>
      </div>
    </div>
    <!-- <div v-if="listK.length" class="indexBtn">
      <span :class="{ active: currentIndex === 1 }" @click="choseIndex(1)">
        成交量
      </span>
      <span :class="{ active: currentIndex === 2 }" @click="choseIndex(2)">
        {{ type.toLocaleUpperCase() }}
      </span>
    </div>
    <div v-if="currentIndex === 1 && listK.length" class="pos-box macd-box">
      <p>
        成交量(手):
        <span>{{ KHoverData[5] == null ? '' : formatNumUnit(KHoverData[5], 2, 10000) }}</span>
      </p>
    </div> -->
    <div v-if="listK.length" :class="['macd-box', isCard && 'card']">
      <template v-if="type == 'macd'">
        <div class="item">
          <span class="label">MACD(12,26,9)</span>
        </div>
        <div class="item">
          <span class="label MACD">MACD:</span>
          <span class="val">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label DIF">DIF:</span>
          <span class="val">{{ KHoverData[10] }}</span>
        </div>
        <div class="item">
          <span class="label DEA">DEA:</span>
          <span class="val">{{ KHoverData[9] }}</span>
        </div>
      </template>
      <template v-if="type == 'kdj'">
        <div class="item">
          <span class="label">KDJ(9,3,3)</span>
        </div>
        <div class="item">
          <span class="label K">K:</span>
          <span class="val K">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label D">D:</span>
          <span class="val D">{{ KHoverData[9] }}</span>
        </div>
        <div class="item">
          <span class="label J">J:</span>
          <span class="val J">{{ KHoverData[10] }}</span>
        </div>
      </template>
      <template v-if="type == 'rsi'">
        <div class="item">
          <span class="label">RSI(6,12,24)</span>
        </div>
        <div class="item">
          <span class="label RSI6">RSI6:</span>
          <span class="val RSI6">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label RSI12">RSI12:</span>
          <span class="val RSI12">{{ KHoverData[9] }}</span>
        </div>
        <div class="item">
          <span class="label RSI24">RSI24:</span>
          <span class="val RSI24">{{ KHoverData[10] }}</span>
        </div>
      </template>
      <template v-if="type == 'ma'">
        <div class="item">
          <span class="label">成交量(手)</span>
          <span class="val">{{ KHoverData[8] == null ? '' : formatNumUnit(KHoverData[5], 2, 10000) }} </span>
        </div>
      </template>
      <template v-if="type == 'boll'">
        <!-- <div class="item">
          <span class="label">BOLL(20,2)</span>
        </div>
        <div class="item">
          <span class="label RSI6">MID:</span>
          <span class="val">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label RSI12">UPPER:</span>
          <span class="val">{{ KHoverData[9] }}</span>
        </div>
        <div class="item">
          <span class="label RSI24">LOWER:</span>
          <span class="val">{{ KHoverData[10] }}</span>
        </div> -->
        <div class="item">
          <span class="label">成交量(手)</span>
          <span class="val">{{ KHoverData[8] == null ? '' : formatNumUnit(KHoverData[5], 2, 10000) }} </span>
        </div>
      </template>
      <template v-if="type == 'bias'">
        <div class="item">
          <span class="label">BIAS(6,12,24)</span>
        </div>
        <div class="item">
          <span class="label RSI6">BIAS:</span>
          <span class="val RSI6">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label RSI12">BIAS2:</span>
          <span class="val RSI12">{{ KHoverData[9] }}</span>
        </div>
        <div class="item">
          <span class="label RSI24">BIAS3:</span>
          <span class="val RSI24">{{ KHoverData[10] }}</span>
        </div>
      </template>
      <template v-if="type == 'wr'">
        <div class="item">
          <span class="label">W&R(10,6)</span>
        </div>
        <div class="item">
          <span class="label RSI6">WR:</span>
          <span class="val RSI6">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label RSI12">WR2:</span>
          <span class="val RSI12">{{ KHoverData[9] }}</span>
        </div>
      </template>
      <template v-if="type == 'psy'">
        <div class="item">
          <span class="label">PSY(12,6)</span>
        </div>
        <div class="item">
          <span class="label RSI6">PSY:</span>
          <span class="val RSI6">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label RSI12">PSYMA:</span>
          <span class="val RSI12">{{ KHoverData[9] }}</span>
        </div>
      </template>
      <template v-if="type == 'dmi'">
        <div class="item">
          <span class="label">DMI(14,6)</span>
        </div>
        <div class="item">
          <span class="label DI1">DI1:</span>
          <span class="val DI1">{{ KHoverData[8] }}</span>
        </div>
        <div class="item">
          <span class="label DI2">DI2:</span>
          <span class="val DI2">{{ KHoverData[9] }}</span>
        </div>
        <div class="item">
          <span class="label ADX">ADX:</span>
          <span class="val ADX">{{ KHoverData[10] }}</span>
        </div>
        <div class="item">
          <span class="label ADXR">ADXR:</span>
          <span class="val ADXR">{{ KHoverData[11] }}</span>
        </div>
      </template>
      <template v-if="type == 'vol'">
        <div class="item">
          <span class="label">VOL(5,10)</span>
        </div>
        <div class="item">
          <span class="label DI1">VOL1(手):</span>
          <span class="val DI1">{{ KHoverData[8] == null ? '' : formatNumUnit(KHoverData[8], 2, 10000) }}</span>
        </div>
        <div class="item">
          <span class="label DI2">VOL5(手):</span>
          <span class="val DI2">{{ KHoverData[9] == null ? '' : formatNumUnit(KHoverData[9], 2, 10000)
          }}</span>
        </div>
        <div class="item">
          <span class="label ADX">VOL10(手):</span>
          <span class="val ADX">{{ KHoverData[10] == null ? '' : formatNumUnit(KHoverData[10], 2, 10000)
          }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { formatNumUnit } from './js/numberFormat'
import moment from 'moment'
import mixin from './js/mixin'
import ChartK from './chartk'

export default {
  name: 'KChart',
  components: {
    ChartK
  },
  props: {
    kdata: {
      type: Array,
      default: () => []
    },
    // 证券代码
    symbol: {
      type: String | Number,
      default: ''
    },
    market: {
      type: String | Number,
      default: ''
    },
    shortName: {
      type: String,
      default: ''
    },
    hasStart: {
      type: Boolean,
      default: false
    },
    // 当前特征线
    curline: {
      type: String,
      default: ''
    },
    // 范围值
    range: {
      type: Number,
      default: 70
    },
    // 横坐标
    xaxis: {
      type: Array,
      default: () => []
    },
    // 买入&&卖出标识数据
    marketData: {
      type: Array,
      default: () => []
    },
    // 刷新图表
    isfresh: {
      type: Boolean,
      default: false
    },
    // 指标类型
    type: {
      type: String,
      default: 'macd'
    },
    // 是否作为聊天窗里的图表块
    isCard: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      securityType: '1', // 品种id 1表示股票 2表示基金 3是债券 11是债券逆回购
      KHoverData: [], // k线hoverdata
      listK: [], // K线处理的数据

      sallOutMark: [], // 买入卖出标识数组
      currentIndex: 1
    }
  },
  watch: {
    kdata: {
      handler: function (n) {
        this.handleKdata(this.kdata)
      },
      deep: true
    },
    listK: {
      handler: function (n) {
        if (!n.length) {
          console.log('触发listK当前为空1000000')
        }
      },
      deep: true
    },
    marketData: {
      handler: function (n) {
        // sessionStorage.setItem('marketData', JSON.stringify(n))
        this.sallOutMark = JSON.parse(JSON.stringify(this.marketData))
      },
      deep: true
    }
  },
  mounted () {
    this.handleKdata(this.kdata)
  },
  created () {
  },
  methods: {
    // 获取k线数据
    getHoverData (data) {
      this.KHoverData = data
    },
    // 切换指标
    choseIndex (index) {
      this.currentIndex = index
      this.KHoverData = []
    },
    handleKdata (arr) {
      if (arr.length > 0) {
        this.listK = arr.map((item) => {
          let base = [

            moment(new Date(item.UTCDateTime)).format('yyyy-MM-DD'),
            item.OpenPrice, // 开盘值
            item.ClosePrice, // 收盘值
            item.LowPrice, // 最低值
            item.HightPrice, // 最高值
            this.numToShou(item.TotalVolumeTraded), // 总量
            item.TotalValueTraded, // 总额
            parseFloat(mixin.accMul(item.ChangeRatio, 100), 2, true) // 涨跌幅
          ]
          if (this.type === 'macd') {
            return [
              ...base,
              item.macd, // macd
              item.macd_dea, // dea
              item.macd_dif // dif
            ]
          } else if (this.type === 'kdj') {
            return [
              ...base,
              item.kdj_k,
              item.kdj_d,
              item.kdj_j
            ]
          } else if (this.type === 'rsi') {
            return [
              ...base,
              item.rsi_6,
              item.rsi_12,
              item.rsi_24
            ]
          } else if (this.type === 'boll') {
            return [
              ...base,
              item.boll_mid,
              item.boll_upper,
              item.boll_lower
            ]
          } else if (this.type === 'ma') {
            return [
              ...base,
              item.ma_5,
              item.ma_10,
              item.ma_20,
              item.ma_60,
              item.ma_120
            ]
          } else if (this.type === 'bias') {
            return [
              ...base,
              item.bias_6,
              item.bias_12,
              item.bias_24
            ]
          } else if (this.type === 'wr') {
            return [
              ...base,
              item.wr_6,
              item.wr_10
            ]
          } else if (this.type === 'psy') {
            return [
              ...base,
              item.psy,
              item.psyma
            ]
          } else if (this.type === 'dmi') {
            return [
              ...base,
              item.dmi_pdi,
              item.dmi_mdi,
              item.dmi_adx,
              item.dmi_adxr
            ]
          } else if (this.type === 'vol') {
            return [
              ...base,
              this.numToShou(item.volma_1),
              this.numToShou(item.volma_5),
              this.numToShou(item.volma_10)
            ]
          }
        })
        // 需要标识的数据
        if (this.marketData.length) {
          this.sallOutMark = JSON.parse(JSON.stringify(this.marketData))
        }
      } else {
        this.listK = []
      }
    },
    // 成交量单位转换为手
    numToShou (num) {
      const volume = mixin.accDiv(num, 100)
      return volume
    },
    // 大数字单位处理(小于10万不处理)
    formatNumUnit (value, fixedLen = 2, num = 100000) {
      return formatNumUnit(value, fixedLen, num)
    },
    clicknode (node) {
      this.$emit('click', node)
    },
    setBottom (type) {
      let p
      if (type === 1) {
        p = '10%'
      } else if (type === 4) {
        p = '10.5%'
      } else if (type === 5) {
        p = '10.5%'
      } else if (type === 7) {
        p = 'calc(10% + 4px)'
      }
      return p
    },
    getma (attr, val) {
      this.$emit('setma', attr, val)
    }
  }
}
</script>
<style lang="less" scoped>
.kChartDetail {
  background-repeat: no-repeat;
  background-position: center center;
  // height: 880rpx;
  margin-bottom: 40rpx;
  width: 100%;
  position: relative;
  background-color: #fff;

  .kTitle {
    background-color: #eff1f8;
    height: 60px;
    line-height: 60px;
    width: 100%;
    padding: 0 30px;
    color: #666;
    font-size: 18px;
  }

  .kRadio {
    height: 50px;
    line-height: 50px;
    padding: 0 30px;
    border-bottom: 1px solid #d9dfea;
  }

  .kChart {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    width: 100%;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    -o-flex-direction: row;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .chart {
      width: 100%;
      height: 100%;

    }

    .quotation {
      margin-top: 20px;
      color: #666;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
      -webkit-flex: 1;
      -moz-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
      flex: 1;

      .title {
        font-size: 16px;
        background-color: #eff1f8;
        height: 40px;
        line-height: 40px;
        width: 100%;
        display: inline-block;
        padding: 0 15px;
      }

      .content {
        font-size: 14px;
        line-height: 45px;
        padding: 0 15px;
        background-color: #f6f7fb;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;

        .text {
          width: 14%;
        }

        .price,
        .rectangle {
          width: 30%;
          color: #666;
        }

        .price {
          text-align: right;
        }

        .rectangle {
          text-align: left;
          padding-left: 4px;

          .el-progress {
            margin-top: 25px;

            /deep/.el-progress-bar__outer {
              background-color: transparent;

              .el-progress-bar__inner {
                background-color: #666;
              }
            }
          }
        }

        .num {
          width: 25%;
          text-align: right;
        }
      }
    }
  }

  .indexBtn {
    left: 0;
    width: 680rpx;
    bottom: calc(10% - 64rpx);
    height: 60rpx;
    // position: absolute;
    background-color: #fff;
    display: flex;
    margin: 0 auto;
    border-radius: 10rpx;
    overflow: hidden;
    border: 1px solid #6C8FF8;
    border-radius: 5px;
    margin-top: 10px;

    text {
      display: block;
      height: 60rpx;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #6C8FF8;
      border-right: none;
      cursor: pointer;
      flex: 1;
      font-size: 26px;

      @media (max-width: 750px) {
        font-size: 18px;
      }

      @media (max-width: 420px) {
        font-size: 14px;
      }

      padding: 5px 0;

      &:first-child {
        border-radius: 5px 0 0 5px;
      }

      &:last-child {
        border-radius: 0 5px 5px 0;
      }
    }

    text:last-child {
      // border-right: 1px solid #6C8FF8;
    }

    .active {
      cursor: pointer;
      color: #fff;
      background: #6C8FF8;
    }
  }

  .macd-box {
    position: absolute;
    top: 58.2%;
    left: 0%;
    color: #333;
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
    z-index: 3;

    @media (max-width: 400px) {
      font-size: 12px;
      top: 58.2%;
    }

    &.card {
      top: 64.2%;
    }
  }

  .nodata {
    display: flex;
    flex-direction: column;

    .nodtx {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #fc985a;
      display: flex;
      height: 100%;
      padding-top: 30px;
    }
  }
}

.nodImg {
  background-image: url("./img/noData.png");
}

.macd-box {
  top: 67.2%;
  left: 8%;
  color: #333;
  font-size: 14px;
}

.label {
  margin-right: 2px;
  color: #333;
}

.val {
  margin-right: 7px;
}

.MACD {
  color: #7499E4;
}

.DEA {
  color: #339900;
}

.DIF {
  color: #FF7786;
}

.D {
  color: #7499E4;
}

.J {
  color: #FF7786;
}

.K {
  color: #339900;
}

.RSI6 {
  color: #7499E4;
}

.RSI12 {
  color: #FF7786;
}

.RSI24 {
  color: #339900;
}

.DI1 {
  color: #7499E4;
}

.DI2 {
  color: #FF7786;
}

.ADX {
  color: #339900;
}

.ADXR {
  color: #ffab42;
}
</style>



// WEBPACK FOOTER //
// src/components/chart/kChart.vue